import GreenhouseGoalTerm from './GreenhouseGoalTerm';

export default GreenhouseGoalTerm;
